import PreviewQuiz from '.';
import { RouteType } from '@/lib/route';

const PreviewQuizRoutes: RouteType = {
  path: '/preview-quiz/:elearningId/:questionId?',
  component: PreviewQuiz,
};

export interface PreviewQuizParamType {
  elearningId: string;
  questionId?: string;
}

export default PreviewQuizRoutes;
